import {Component, Input, OnChanges} from '@angular/core';

import {chartColors} from '../../../core/constants';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {ChartDataset, ChartOptions, ChartType} from 'chart.js';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css'],
  standalone: false,
})
export class PieChartComponent implements OnChanges{
  @Input() public pieChartLabels!: string[];
  @Input() public pieChartData!: ChartDataset[];
  @Input() public showLegend = false;
  @Input() public pieChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          generateLabels: (chart) => {
            const data = chart.data;
            if (chart.legend && data.labels?.length && data.datasets.length) {
              return data.labels.map((label, i) => {
                const ds = data.datasets[0];
                const meta = chart.getDatasetMeta(0);
                const style = meta.controller.getStyle(i, true);
                return {
                  text: `${label}: ${ds.data[i]} %`,
                  fontColor: style.color,
                  fillStyle: style.backgroundColor,
                  strokeStyle: '#ffffff00',
                  lineWidth: style.borderWidth,
                  hidden: !chart.getDataVisibility(i),
                  index: i
                };
              });
            }
            return [];
          }
        }
      },
      datalabels: {
        formatter: (value) => {
          return `${value}%`;
        },
        anchor: 'center',
        align: 'end',
      },
    }
  };

  public pieChartType: ChartType = 'pie';
  public pieChartPlugins = [ChartDataLabels];


  ngOnChanges() {
    this.pieChartData.forEach((chartDatum) => {
      chartDatum.backgroundColor = chartColors;
    });
  }
}
